import type { RouteDefinition } from "./route-definition.ts";

export const docsRoutes = {
  docs: {
    path: "/docs/*slug?",
    scope: "static",
    bucket: "docs",
    entry: "nav",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
